import {
	BORDER_WIDTH,
	END_STAND_WIDTH,
	FREESTANDING_SECTIONS_WIDTH,
} from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { Section } from '@/shared/types/configurator';

export const calculateSectionLeftPositions = (sections: Section[], wallMounted: boolean) => {
	let existsWidth: number = 0;
	const result: Record<number, number> = {};

	for (let sectionIndex = 0; sectionIndex < sections.length; sectionIndex++) {
		const section = sections[sectionIndex];
		result[sectionIndex] = existsWidth;

		if (wallMounted) {
			existsWidth += (section.width + BORDER_WIDTH) * DISPLAY_SCALE;
		} else {
			const borderWidth = BORDER_WIDTH + END_STAND_WIDTH;
			existsWidth +=
				(section.width + borderWidth * 2 + FREESTANDING_SECTIONS_WIDTH) * DISPLAY_SCALE;
		}
	}

	return result;
};
